import React from "react";

const CircularProgress = ({ current, total, strokeWidth = 15, styleData }) => {
    // Координатная сетка (viewBox) 100x100:
    const SVG_SIZE = 100;

    // Ограничиваем current, чтобы не было больше total
    const safeCurrent = Math.min(current, total);

    // Считаем прогресс в долях (от 0 до 1)
    const progress = safeCurrent / total;

    // Радиус круга (учитываем половину толщины обводки)
    // Так как "центр" в (50, 50), то максимальный радиус = 50
    const radius = 50 - strokeWidth / 2;

    // Длина окружности = 2πr
    const circumference = 2 * Math.PI * radius;

    // Смещение "штриха" для круга прогресса
    const offset = circumference - circumference * progress;

    return (
        <svg
            viewBox={`0 0 ${SVG_SIZE} ${SVG_SIZE}`}
            style={{ width: "100%", height: "auto" }}
            // ↑ Это главное: "width: 100%" делает SVG резиновым
        >
            {/* Фоновый круг (задний план) */}
            <circle
                cx="50"          // Центр круга (по X)
                cy="50"          // Центр круга (по Y)
                r={radius}       // Радиус
                fill="none"
                stroke="#444"    // Цвет заднего плана
                strokeWidth={strokeWidth}
            />

            {/* Круг прогресса (передний план) */}
            <circle
                cx="50"
                cy="50"
                r={radius}
                fill="none"
                stroke="#FFD700"               // Основной цвет прогресса
                strokeWidth={strokeWidth}
                strokeDasharray={circumference}
                strokeDashoffset={offset}
                strokeLinecap="round"
                style={{ transition: "stroke-dashoffset 0.5s" }}
            />

            {/* Текст в центре (например "400/1000") */}
            <text
                x="50%"
                y="50%"
                dy="0.3em"
                textAnchor="middle"
                fill={styleData.barTextColor}
                fontSize="1.1rem"
                fontWeight="bold"
            >
                {`${current}/${total}`}
            </text>
        </svg>
    );
};

export default CircularProgress;